import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolQuotesAction } from '../symbolQuotes.action';
import { IQuoteLpSymbolRow } from '../symbolQuotes.interface';

type IDependencies = IClientApiDependencySegment;

/** Thin paginated loader for the LP route's LP-symbol rows (decoupled from the infinity grid). */
export const loadLpSymbolsEpic: IEpic<{}, IDependencies> = (action$, _, { api }) =>
  action$.pipe(
    isTypeOfAndGetPayload(SymbolQuotesAction.loadLpSymbols.started),
    mergeMap((params) =>
      api.getLpSymbolList({
        lpId: params.lpId,
        symbolGroup: params.symbolGroup,
        search: params.search,
        limit: params.limit,
        skip: params.skip,
      }).pipe(
        mergeMap((response) => {
          const items: IQuoteLpSymbolRow[] = response.lpSymbols.map((symbol) => ({
            lpSymbolName: symbol.name,
            coreSymbolName: symbol.coreSymbolName ?? '',
            coreSymbolId: symbol.coreSymbolId,
            scheduleName: symbol.schedule?.name,
          }));
          return [SymbolQuotesAction.loadLpSymbols.done({ params, result: { items, total: response.filteredCount } })];
        }),
        catchApiError((error) => [
          SymbolQuotesAction.loadLpSymbols.failed({ params, error }),
          createApiErrorNotification(error),
        ]),
      ),
    ),
  );
